// removed by extract-text-webpack-plugin
module.exports = {"batchItem":"R9BAKRiLtXANpvARvryVq","deleteButton":"_34lIGnDZY_hR3p2iIWoEh7 _1Uj5o1UduacBi1haDoWWh3"};